<template>
  <!-- 
   邀请链接配置参数：key=pcjj&roomNum=房间号&gameId=游戏id
   pcjj：游戏拼音首字母小写，由房间页面复制出来
   如无参数，此页面显示为下载页面
  -->
  <div class="page">
    <div class="page-bg">
      <!-- 邀请显示内容 -->
      <template v-if="pageType === 1">
        <img class="img1 block" src="../assets/images/share/2.jpg" alt="">
        <img class="img2 block" src="../assets/images/logo.png" alt="">
        <img class="img3 block" src="../assets/images/share/1.jpg" alt="">

        <div class="box">
          <img class="img4 block" :src="require('../assets/images/share/'+ key +'.png')" alt="">
          <div class="h1">{{ title }}</div>
          <div class="h2">{{ eng }}</div>
          <div class="btn"
            v-clipboard:copy="content"
            v-clipboard:success="firstCopySuccess"
            v-clipboard:error="firstCopyError"
          >打开拼词之星</div>
          <div class="h3" v-if="roomNum"
          >房间号：{{ roomNum }}</div>
        </div>
        <img class="img5 block" src="../assets/images/share/jinbi.png" alt="">
      </template>
      <!-- 下载显示内容 -->
      <template v-else>
        <img class="img6 block" src="../assets/images/logo_icon.png" alt="">
        <div class="package-name">拼词之星</div>
        <div class="version">{{ version }}</div>
        <div class="version" v-if="!androidDownloadUrl">适用于iOS设备</div>
        <img class="block qr" src="../assets/images/share/shareqr.jpg" alt="">
        <div class="btn btn2" @click="openApp">下载安装</div>
      </template>
      <div class="mask" v-if="showMask">
        <img class="arrow" src="../assets/images/arrow.png" alt="">
        <div class="tip">请在浏览器中打开</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      roomNum: '',
      typeList: [
        { key: 'pcjj', title: '拼词竞技', eng: 'Word Competition', mode: '拼词竞技|联机模式', path: 'pages/games/pcjj/game_pcjj_find_room' },
        { key: 'jspc', title: '极速拼词', eng: 'Speed Spell', mode: '极速拼词|联机模式', path: 'pages/games/jspc/game_jspc_find_room' },
        { key: 'zmjl', title: '字母接龙', eng: 'Letter By Letter', mode: '字母接龙|联机模式', path: 'pages/games/zmjl/game_zmjl_find_room' },
        { key: 'xspc', title: '线索拼词', eng: 'Show And Spell', mode: '线索拼词|联机模式', path: '' },
        { key: 'hysc', title: '慧眼识词', eng: 'Laser Letters', mode: '慧眼识词|联机模式', path: '' },
        { key: 'cytz', title: '词源挑战', eng: 'Origins Challenge', mode: '词源挑战|联机模式', path: '' },
        { key: 'nwwd', title: '你问我答', eng: 'Guess And Spell', mode: '你问我答|联机模式', path: '' },
        { key: 'jggpc', title: '九宫格拼词', eng: 'Super Words', mode: '九宫格拼词|联机模式', path: '' },
      ],
      key: '',
      title: '',
      eng: '',
      gameMode: '',
      path: '',
      hasApp: true,
      showMask: false,
      androidDownloadUrl: '',
      version: '',
      gameId: '',
      gameInfo: '',
      content: '',
      pageType: 1 // 1-邀请链接（链接拼参数） 2-下载链接（链接无参数）直接下载
    }
  },
  created () {
    this.showMask = false
    this.checkBrowser()
    this.pageType = this.$route.query.roomNum ? 1 : 2
    this.getAppInfo()
    this.watchVisibility()
    if (this.pageType === 1) { // 邀请时，获取数据
      this.roomNum = this.$route.query.roomNum
      this.gameId = this.$route.query.gameId
      let key = this.$route.query.key
      this.key = key
      let currentGame = this.typeList.find(item => item.key === key)
      this.title = `｜${currentGame.title}｜`
      this.eng = currentGame.eng
      this.gameMode = currentGame.mode
      this.path = currentGame.path
      this.getGameInfo()
    }
  },
  methods: {
    checkBrowser () {
      if (/(micromessenger)/i.test(navigator.userAgent)) { 
      //是否电脑微信或者微信开发者工具
        if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
          console.log('电脑微信或者微信开发者工具')
        }else{
          //手机微信打开的浏览器
          console.log('手机微信')
          this.showMask = true
        }
      }
    },
    getAppInfo () {
      this.$http.get('/config/ajax_app_info').then(res => {
        if (res.code === 200) {
          this.androidDownloadUrl = res.data.android_url
          const userAgent = navigator.userAgent;
          if (/iPhone|iPod|iPad/i.test(userAgent)) {
            this.version = res.data.ios_version
          } else if (/android/i.test(userAgent)) {
            this.version = res.data.android_version
          }
        }
      })
    },

    openApp() {
      //是否是微信浏览器
      if (/(micromessenger)/i.test(navigator.userAgent)) { 
      //是否电脑微信或者微信开发者工具
        if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
          console.log('电脑微信或者微信开发者工具')
        }else{
          //手机微信打开的浏览器
          console.log('手机微信')
          this.showMask = true
        }
      } else {
        console.log('其他浏览器')
        const CONFIG = {
          iosScheme: "pczx://pages/tabbar/home/index", // iOS 应用 URL
          iosDownload: "https://apps.apple.com/cn/app/%E6%8B%BC%E8%AF%8D%E4%B9%8B%E6%98%9F/id6504004311", // iOS 下载页面 URL
          androidScheme: "pczx://pages/tabbar/home/index", // Android 应用 URL
          androidDownload: this.androidDownloadUrl, //Android 下载页面 URL
        };
        const userAgent = navigator.userAgent;
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 确保 iframe 不会显示在页面上
        // const startTime = new Date().getTime();
        this.hasApp = true; // 假设设备上已安装应用
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁止背景点击
          message: '请稍后...'
        })

        const second = this.pageType === 1 ? 3000 : 0

        if (/iPhone|iPod|iPad/i.test(userAgent)) {
          this.timer = setTimeout(() => {
            // const endTime = new Date().getTime();
            // if (endTime - startTime < 2000) {
              this.hasApp = false;
              window.location.href = CONFIG.iosDownload; // 跳转到 iOS 下载页面的 URL
            // }
            document.body.removeChild(iframe);
          }, second);
          if (this.pageType === 1) {
            iframe.src = CONFIG.iosScheme; // 尝试打开 iOS 应用的 URL
            window.location.href = CONFIG.iosScheme
          }
        } else if (/android/i.test(userAgent)) {
          if (CONFIG.androidDownload) {
            this.timer = setTimeout(() => {
              // const endTime = new Date().getTime();
              // if (endTime - startTime < 2000) {
                this.hasApp = false;
                window.location.href = CONFIG.androidDownload; // 跳转到 Android 下载页面的 URL
              // }
              document.body.removeChild(iframe);
            }, second);
          } else {
            this.$toast('安卓版本暂未开放，敬请期待！')
          }
          if (this.pageType === 1) {
            iframe.src = CONFIG.androidScheme; // 尝试打开 Android 应用的 URL
            window.location.href = CONFIG.androidScheme
          }
        }
      }
    },
    firstCopySuccess(res) {
      console.log(res)
      this.openApp()
      // this.$toast("已复制到剪贴板");
    },
    firstCopyError() {
      // this.$toast("复制失败");
    },

    getGameInfo() {
      this.$http.get('game/ajax_info', { params: { id: this.gameId }}).then(res => {
        if (res.code === 200) {
          this.gameInfo = res.data
          const obj = { 
            h5: 1,
            gameMode: this.gameMode,
            path: this.path,
            gameInfo: this.gameInfo,
            roomNum: this.roomNum
          }
          this.content = JSON.stringify(obj)
        }
      })
    },
    copyToClipboard() {
      const obj = { 
        h5: 1,
        gameMode: this.gameMode,
        path: this.path
      }
      this.$copyText(obj).then(() => {
        // alert('复制成功');
        // 复制成功的操作
      }, () => {
        // alert('复制失败');
        // 复制失败的操作
      });
    },
    watchVisibility() {
      window.addEventListener('visibilitychange', () => {
        // 监听页面visibility
        if(document.hidden) {
          // 如果页面隐藏了，则表示唤起成功，这时候需要清除下载定时器
          clearTimeout(this.timer)
        }
      })
    },

    openFn () {

    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/style/common.less";
.page{
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle, #373632, #140e01);
  overflow-x: hidden;
  overflow-y: auto;
}
.page-bg{
  width: 100%;
  height: 100%;
  background-image: url(../assets/images/share/diwen.png);
  background-size: 100% auto;
  background-position: center;
  background-repeat: repeat-y;
  padding-top: 40px;
  box-sizing: border-box;
}
.block{
  display: block;
  margin: 0 auto;
}
.img1{
  width: 36%;
  margin-bottom: 16px;
}
.img2{
  width: 60px;
  margin-bottom: 12px;
}
.img3{
  width: 52%;
}
.img5{
  width: 100%;
  height: auto;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
.box{
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  margin: 20px;
  text-align: center;
  padding: 12px;
  position: relative;
  z-index: 10;
}
.img4{
  width: 100px;
}
.h1{
  font-family: hzgb;
  font-size: 22px;
  color: #fff;
  margin: 10px 0 4px;
}
.h2{
  font-family: hzgb;
  font-size: 12px;
  color: #fff;
}
.btn{
  background: linear-gradient(to bottom, #ffd16b, #fff497);
  box-shadow: 0 6px 0 0 #d9b059;
  width: 200px;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  font-size: 16px;
  color: #000;
  font-weight: 900;
  margin: 20px auto;
}
.h3{
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}
.mask{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.35);
  z-index: 10000;
  font-size: 16px;
  .arrow{
    position: absolute;
    right: 30px;
    top: 10px;
    width: 100px;
  }
  .tip{
    color: #c89d41;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    width: 50%;
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    border-radius: 60px;
    position: absolute;
    top: 52px;
    left: 54px;
  }
}

.img6{
  width: 100px;
  height: auto;
  border: 2px solid #1c170d;
  border-radius: 16px;
  margin-top: 60px;
}
.package-name{
  color: #fff;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-top: 40px;
}
.version{
  color: #fff;
  text-align: center;
  font-size: 16px;
  margin-top: 4px;
}
.qr{
  width: 140px;
  height: auto;
  margin-top: 20px;
}
.btn2{
  text-align: center;
  border-radius: 40px;
  margin-top: 60px;
}
</style>